import React, { useState } from "react";
import AppBar from "src/components/AppBar/AppBar";
import { IconName } from "src/components/Icon/Icon";
import * as S from "../../constants/StringConstants";
import ApplicationsTable from "./ApplicationsTable";
import "./CommandCenter.scss";
import TasksTable from "./TasksTable";

const CommandCenter = () => {
  const [date, setDate] = useState(new Date());

  return (
    <div className="table-view-v2__content">
      <div className="table-view__header-buttons-container command-center-header">
        <AppBar icon={IconName.CommandCenter} title={S.CMD_CENTER_PAGE_TITLE} />
      </div>
      <br />
      <TasksTable date={date} onDateChange={setDate} />
      <br />
      <ApplicationsTable date={date} />
    </div>
  );
};

export default CommandCenter;
